import React, { useState, useEffect } from "react";
import { Button, Space, Table, notification, Tooltip, Form, Tabs } from "antd";
import style from "./index.module.scss";
import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";
import FormFilter from "./components/FormFilter";
import userEventApi from "api/userEvent";
import * as XLSX from 'xlsx';
import { toast } from "react-toastify";
import ModalImport from "./components/ModalImport";
import { CloudUploadOutlined } from "@ant-design/icons";
import { getUser } from "utils/index";
import { areaTabs } from "constants/index";

const cx = classNames.bind(style);
export default function ListUser() {
  const [formSearch] = Form.useForm();
  const [formImport] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();

  const { t } = useTranslation();

  const [tab, setTab] = useState("1");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openImport, setOpenImport] = useState(false)

  const onOpenImport = () => {
    setOpenImport(true)
  }

  const closeModalImport = () => {
    setOpenImport(false)
    formImport.resetFields()
  }

  const onImport = async (values) => {
    try {
      const reader = new FileReader();
      const rABS = !!reader.readAsBinaryString;
      setLoading(true)
      reader.onload = async (e) => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        if (Array.isArray(data) && data.length >= 4) {
          let payload = []
          let error = ''
          data.filter(item => item.length > 0 && item).forEach((item, idx) => {
            const [
              areaManager,
              code,
              firstName,
              lastName,
            ] = item
            payload.push({
              areaManager,
              code,
              firstName,
              lastName,
              area: tab,
            })
          })
          if (!error) {
            try {
              const body = {
                users: payload,
              }
              await userEventApi.create(body)

              openNotificationWithIcon("success", t('notification'), t('importSuccess'));
              fetchUser()
              closeModalImport()
            } catch (error) {
              openNotificationWithIcon("error", t('error'), t('hasError'));
            } finally {
              setLoading(false)
            }
          } else {
            openNotificationWithIcon("error", t('error'), error || t('hasError'));
          }

        } else toast.error("Import error!")

        /* Update state */
      };
      if (rABS) reader.readAsBinaryString(values.upload[0].originFileObj);
      else reader.readAsArrayBuffer(values.upload[0].originFileObj);
    } catch (error) {
      // toast.error(error?.response?.data || ERROR_OCCUR)
    } finally {
    }
  }

  const columns = [
    {
      title: t('departmentManager'),
      dataIndex: "areaManager",
      key: "areaManager",
    },
    {
      title: t('code'),
      dataIndex: "code",
      key: "code",
    },
    {
      title: t('firstName'),
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: t('lastName'),
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: t('join'),
      dataIndex: "join",
      key: "join",
      render: (_, record) => record?.isJoined ? 'X' : ''
    },
    {
      title: t('notJoin'),
      dataIndex: "notJoin",
      key: "notJoin",
      render: (_, record) => typeof record?.isJoined === 'boolean' && !record?.isJoined ? 'X' : ''
    },
    {
      title: t('unregistered'),
      dataIndex: "unregistered",
      key: "unregistered",
      render: (_, record) => record?.isJoined === undefined ? 'X' : ''
    },
  ]

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({ message, description });
  };

  const fetchUser = async () => {
    try {
      setLoading(true)
      const res = await userEventApi.getAll({
        areaManager: formSearch.getFieldValue('areaManager'),
        code: +formSearch.getFieldValue('code') || undefined,
        firstName: formSearch.getFieldValue('firstName'),
        lastName: formSearch.getFieldValue('lastName'),
        area: tab,
        unregistered: formSearch.getFieldValue('unregistered'),
      });
      setData(res.userEvent || [])
    } catch (error) {
      console.log("🚀 ~ error:", error)
    } finally {
      setLoading(false)
    }
  }

  const onChangeTab = (key) => {
    setTab(key)
  }

  useEffect(() => {
    fetchUser()
  }, [tab])

  return (
    <div className={cx("page-sushi")}>
      {contextHolder}
      <div className={cx("title")}>
        <p>{t("listEmployee")}</p>
      </div>
      <Tabs
        activeKey={tab}
        type="card"
        items={areaTabs.map(item => ({
          ...item,
          disabled: loading,
        }))}
        onChange={onChangeTab}
      />
      <FormFilter loading={loading} form={formSearch} submit={fetchUser} />
      {
        getUser()?.user_name === 'admin' &&
        <Button size="large" icon={<CloudUploadOutlined />} onClick={onOpenImport} loading={loading}>
          {t('import')}
        </Button>
      }
      <br />
      <br />
      <ModalImport loading={loading} show={openImport} onFinish={onImport} form={formImport} onCancel={closeModalImport} />
      <Table
        loading={loading}
        columns={columns}
        dataSource={data}
        bordered
        pagination={false}
        sticky
        summary={(pageData) => {
          return (
            <Table.Summary fixed>
              <Table.Summary.Row className={cx('')}>
                <Table.Summary.Cell index={0} align="left" className="cell-total">
                  <b>{t('sum')}</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} colSpan={3} align="left" className="cell-total">
                  <b>{pageData.length}</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} align="left" className="cell-total">
                  <b>{pageData.reduce((total, item) => total + (item.isJoined ? 1 : 0), 0)}</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} align="left" className="cell-total">
                  <b>{pageData.reduce((total, item) => total + (typeof item?.isJoined === 'boolean' && !item?.isJoined ? 1 : 0), 0)}</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} align="left" className="cell-total">
                  <b>{pageData.reduce((total, item) => total + (item?.isJoined === undefined ? 1 : 0), 0)}</b>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )
        }}
      />
    </div >
  );
}
